import {
  useDashboardUIActions,
  useDashboardUIContext,
} from "@contexts/dashboardUI";
import { useAuthContext, useAuthActions } from "@contexts/auth";
import { useProjectContext } from "@contexts/projects";
import { useEffect, useMemo, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import TitleAnnulmentsMenuItem from "@components/titleAnnulments/TitleAnnulmentsMenuItem";

const Offcanvas = () => {
  const { user } = useAuthContext();
  const { showOffcanvas } = useDashboardUIContext();
  const { toggleOffcanvas } = useDashboardUIActions();
  const { projects, companies } = useProjectContext();
  const { updatePassword } = useAuthActions()
  const { logout } = useAuthActions()
  const { pathname } = useLocation();
  const [response, setResponse] = useState({
    done: false,
    ok: false,
    responseHead: '',
    responseText: '',
  })

  const [passwordForm, setPasswordForm] = useState({
    oldPassword: '',
    newPassword: '',
    newPasswordConfirmation: ''
  })

  // Hoje quem tem acesso a muitas obras (usuários internos) precisa "caçar" a obra numa
  // lista plana sem indicação de construtora. Agrupar por construtora — com as duas listas
  // (grupos e obras dentro de cada grupo) em ordem alfabética — resolve isso sem precisar de
  // nenhuma chamada nova: `projects` já traz `company_id` e `companies` já está no contexto.
  const projectsByCompany = useMemo(() => {
    const companyName = (companyId) => (
      companies?.find((c) => String(c._id) === String(companyId))?.name || "Outras obras"
    );
    const groups = {}
    for (const project of (projects || [])) {
      const label = companyName(project.company_id)
      groups[label] = groups[label] || []
      groups[label].push(project)
    }
    return Object.entries(groups)
      .sort(([a], [b]) => a.localeCompare(b, "pt-BR"))
      .map(([company, groupProjects]) => ([
        company,
        [...groupProjects].sort((a, b) => (a.building_name || "").localeCompare(b.building_name || "", "pt-BR")),
      ]))
  }, [projects, companies])

  const path = useMemo(() => {
    // return '66eacb4976d7c7909b0e9a91' //HARDCODED
    const projectId = pathname.split("/").pop();
    if (projects?.find(({ _id }) => _id === projectId)) {
      return pathname.slice(0, pathname.lastIndexOf("/"))
    }
    return pathname;
  }, [pathname, projects])

  const handleInput = (e) => {
    setPasswordForm(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }


  const handleSend = async (e) => {
    e.preventDefault()
    if (passwordForm.newPassword !== passwordForm.newPasswordConfirmation) {
      setResponse({
        done: true,
        ok: false,
        responseHead: "Erro",
        responseText: "As senhas não coincidem"
      })
      return;
    }
    const response = await updatePassword({ ...passwordForm, email: user.email })
    if (response.ok) {
      setPasswordForm({ newPassword: '', oldPassword: '', newPasswordConfirmation: '' })
      setResponse({
        done: true,
        ok: true,
        responseHead: "Sucesso!",
        responseText: "Senha alterada com sucesso."
      })
    } else {
      setResponse({
        done: true,
        ok: false,
        responseHead: "Erro",
        responseText: "Senha incorreta."
      })
    }
  }

  return (
    <div className={showOffcanvas ? "offcanvas active" : "offcanvas"}>
      <div className="offcanvas-container small">
        <hgroup className="offcanvas-header">
          <div className="offcanvas-header-infos">
            <i className="icon icon-width-24 icon-user-circle background-accent"
              aria-hidden={true} />
            <div>
              <h2>{user?.name}</h2>
              <p>{user?.email}</p>
            </div>
          </div>
          <button onClick={toggleOffcanvas}>
            <i
              className="icon icon-width-24 icon-times background-accent"
              aria-hidden={true}
            ></i>
          </button>
        </hgroup>
        <div className="offcanvas-content">
          <hr className="divider" />
          <details>
            <summary><span>Selecionar obra</span></summary>
            <nav className="offcanvas-nav offcanvas-nav--grouped">
              {projectsByCompany.map(([company, groupProjects]) => (
                <div className="offcanvas-company-group" key={company}>
                  <span className="offcanvas-company-label">{company}</span>
                  {groupProjects.map((project) => (
                    <NavLink onClick={toggleOffcanvas} to={`${path}/${project._id}`} key={project._id}>
                      {project.building_name}
                    </NavLink>
                  ))}
                </div>
              ))}
            </nav>
          </details>
          <TitleAnnulmentsMenuItem />
          <hr className="divider" />
          <details>
            <summary><span>Trocar senha</span></summary>
            <form className="new-password-container">
              {response.done && <div className={`alert alert-${response.ok ? "success" : "error"} margin-top-32`}>
                <h3 className="info-title">{response.responseHead}</h3>
                <p>{response.responseText}</p>
              </div>}
              <label>Senha atual</label>
              <input type="password" name='oldPassword' onChange={handleInput} value={passwordForm.oldPassword} />
              <label>Nova senha</label>
              <input type="password" name='newPassword' onChange={handleInput} value={passwordForm.newPassword} />
              <label>Confirme sua nova senha</label>
              <input type="password" name='newPasswordConfirmation' onChange={handleInput} value={passwordForm.newPasswordConfirmation} />
              <button className="button button-accent" onClick={handleSend}>Enviar</button>
            </form>
          </details>
          <hr className="divider" />
          <button onClick={logout}>
            <span>Sair</span>
            <i
              className="icon icon-width-24 icon-sign-out background-gray"
              aria-hidden={true}
            ></i>
          </button>


        </div>
      </div>
      {showOffcanvas && <div onClick={toggleOffcanvas} className="offcanvas-background" />}

    </div>
  );
};

export default Offcanvas;
